import waitingTimesService from '../../services/waitingtimes'

const state = {
    currentWaitingTime: ''
}

// getters
const getters = {
    
}

// actions
const actions = {
    async updateCurrentWaitingTimeAction(context, data) {
        await waitingTimesService.updateCurrentWaitingTimeByRestaurant(data);
        context.commit('setCurrentWaitingTimeState', data);
    }
}

// mutations
const mutations = {
    setCurrentWaitingTimeState(state, data) {
        state.currentWaitingTime = data;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}